import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MembershipTiers = () => {
  const navigate = useNavigate();

  const handleStartNow = () => {
    navigate('/user-registration');
  };

  const tiers = [
    {
      id: 1,
      name: "Explorador",
      price: "$20.000",
      period: "COP/mes",
      icon: "Compass",
      color: "bg-gradient-to-br from-blue-500 to-blue-700",
      borderColor: "border-blue-500",
      badgeColor: "bg-blue-500",
      iconBg: "bg-blue-100",
      iconColor: "text-blue-700",
      features: [
        "Acceso a la plataforma",
        "Escaneo QR",
        "500 Notificaciones",
        "Historial de descuentos",
        "Soporte por Email"
      ],
      discountLimit: "Ideal para empezar",
      notificationQuota: "15 descuentos/mes"
    },
    {
      id: 2,
      name: "Emprendedor",
      price: "$50.000",
      period: "COP/mes",
      icon: "TrendingUp",
      color: "bg-gradient-to-br from-accent to-orange-600",
      borderColor: "border-accent",
      badgeColor: "bg-accent",
      iconBg: "bg-orange-100",
      iconColor: "text-orange-700",
      popular: true,
      features: [
        "Acceso a la plataforma",
        "Escaneo QR",
        "2000 Notificaciones",
        "Historial de descuentos",
        "Programa Bizznet Rewards",
        "Soporte prioritario"
      ],
      discountLimit: "Para Usuarios Activos",
      notificationQuota: "50 descuentos/mes"
    },
    {
      id: 3,
      name: "Elite",
      price: "$70.000",
      period: "COP/mes",
      icon: "Crown",
      color: "bg-gradient-to-br from-primary to-purple-700",
      borderColor: "border-primary",
      badgeColor: "bg-primary",
      iconBg: "bg-purple-100",
      iconColor: "text-purple-700",
      features: [
        "Acceso a la plataforma",
        "Notificaciones ilimitadas",
        "Escaneo QR",
        "Programa Bizznet Rewards",
        "Historial de descuentos",
        "Soporte 24/7 dedicado"
      ],
      discountLimit: "Experiencia Premium",
      notificationQuota: "descuentos Ilimitados"
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 px-4 sm:px-6 bg-gradient-to-b from-background to-muted">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 sm:mb-14 md:mb-16 lg:mb-20">
          <div className="inline-block mb-3 sm:mb-4">
            <span className="bg-primary/10 text-primary px-4 sm:px-5 md:px-6 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-bold uppercase tracking-wider">
              Planes de Membresía
            </span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-extrabold text-foreground mb-4 sm:mb-5 md:mb-6 px-2">
            Elige Tu Plan Perfecto
          </h2>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-muted-foreground max-w-3xl mx-auto font-medium px-4">
            Descubre el plan que mejor se adapte a tus necesidades y comienza a ahorrar hoy mismo
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-7 md:gap-8 lg:gap-10">
          {tiers?.map((tier) => (
            <div
              key={tier?.id}
              className={`relative bg-white rounded-2xl sm:rounded-3xl shadow-2xl border-3 sm:border-4 ${
                tier?.popular ? `${tier?.borderColor} transform md:scale-105 lg:scale-110 z-10` : 'border-gray-200'
              } p-5 sm:p-6 md:p-7 lg:p-8 xl:p-10 transition-all duration-300 hover:shadow-3xl hover:-translate-y-2 flex flex-col`}
            >
              {tier?.popular && (
                <div className={`absolute -top-4 sm:-top-5 left-1/2 -translate-x-1/2 ${tier?.badgeColor} text-white px-5 sm:px-6 md:px-8 py-1.5 sm:py-2 rounded-full text-sm sm:text-base font-bold shadow-lg`}>
                  🔥 Más Popular
                </div>
              )}

              <div className="flex flex-col items-center text-center space-y-5 sm:space-y-6 md:space-y-7 lg:space-y-8 flex-1">
                <div className={`flex items-center justify-center w-16 h-16 sm:w-18 sm:h-18 md:w-20 md:h-20 ${tier?.iconBg} ${tier?.iconColor} rounded-xl sm:rounded-2xl shadow-lg transform hover:scale-110 transition-transform duration-300`}>
                  <Icon name={tier?.icon} size={32} className="sm:hidden" />
                  <Icon name={tier?.icon} size={36} className="hidden sm:block md:hidden" />
                  <Icon name={tier?.icon} size={40} className="hidden md:block" />
                </div>

                <div>
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-foreground mb-3 sm:mb-4">{tier?.name}</h3>
                  <div className="flex items-baseline justify-center gap-1 sm:gap-1.5">
                    <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
                      {tier?.price}
                    </span>
                    <span className="text-sm sm:text-base text-muted-foreground font-semibold">{tier?.period}</span>
                  </div>
                </div>

                <div className="w-full space-y-2.5 sm:space-y-3">
                  <div className={`${tier?.color} text-white rounded-lg sm:rounded-xl p-3 sm:p-3.5 md:p-4 shadow-md`}>
                    <p className="text-sm sm:text-base font-bold">{tier?.discountLimit}</p>
                  </div>
                  <div className="bg-gradient-to-r from-gray-100 to-gray-200 rounded-lg sm:rounded-xl p-3 sm:p-3.5 md:p-4 shadow-md">
                    <p className="text-sm sm:text-base font-bold text-gray-800">{tier?.notificationQuota}</p>
                  </div>
                </div>

                <div className="w-full flex-1 flex flex-col">
                  <ul className="w-full space-y-3 sm:space-y-3.5 md:space-y-4 pt-3 sm:pt-4 flex-1">
                    {tier?.features?.map((feature, index) => (
                      <li key={index} className="flex items-start gap-2 sm:gap-2.5 md:gap-3 text-left">
                        <div className="flex-shrink-0 mt-0.5 sm:mt-1">
                          <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-green-100 flex items-center justify-center">
                            <Icon name="Check" size={14} color="#16a34a" className="sm:hidden font-bold" />
                            <Icon name="Check" size={16} color="#16a34a" className="hidden sm:block font-bold" />
                          </div>
                        </div>
                        <span className="text-sm sm:text-base text-foreground font-medium leading-relaxed">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="mt-5 sm:mt-6 md:mt-7 lg:mt-8">
                    <Button
                      variant={tier?.popular ? "default" : "outline"}
                      size="lg"
                      fullWidth
                      iconName="ArrowRight"
                      iconPosition="right"
                      onClick={handleStartNow}
                      className={`font-bold text-base sm:text-lg py-4 sm:py-5 md:py-6 transform hover:scale-105 transition-all duration-300 shadow-lg ${
                        tier?.popular ? tier?.color + ' text-white border-0 hover:shadow-2xl' : 'border-2 sm:border-3 hover:bg-gray-50'
                      }`}
                    >
                      Comenzar Ahora
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 sm:mt-12 md:mt-14 lg:mt-16 text-center bg-blue-50 border-2 border-blue-200 rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 max-w-3xl mx-auto">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3">
            <Icon name="Info" size={20} className="sm:hidden text-blue-600 flex-shrink-0" />
            <Icon name="Info" size={22} className="hidden sm:block md:hidden text-blue-600 flex-shrink-0" />
            <Icon name="Info" size={24} className="hidden md:block text-blue-600 flex-shrink-0" />
            <p className="text-sm sm:text-base text-blue-900 font-semibold text-center sm:text-left">
              Membresías válidas por 30 días • Renovación automática disponible • Cancela cuando quieras
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MembershipTiers;